export const EntityFormMode = Object.freeze({
  'ADD': 'ADD',
  'EDIT': 'EDIT',
  'VIEW': 'VIEW',
})